import { ISeller } from 'models/Seller';

export const formatSeller = (seller?: ISeller, customerBus?: Array<string>) => {
  if (!seller || !seller?.name) return '';

  const sellerName = seller?.name ? seller?.name : '';
  const bu = customerBus && customerBus.length > 0
    ? `${` (${customerBus.toString()})`}`
    : '';

  return `${sellerName}${bu}`;
};
